// import React from 'react';
// import Modal from 'react-bootstrap/Modal';

// const BookingConfirmationModal = ({ show, onHide, onContinue, onBookWithSupplier }) => {
//   return (
//     <Modal show={show} onHide={onHide} centered>
//       <Modal.Body className="text-center p-4">
//         <div className="mb-3">
//             <i className="ri-information-line fs-1 text-primary"></i>
//         </div>
//         <h4 className="fw-bold">Booking Confirmation</h4>
//         <p className="text-muted mt-3">
//           To continue booking this flight on our platform, a transaction fee will be applicable.
//         </p>
//         <p className="text-muted">
//           Alternatively, you can book directly on the supplier's portal without this fee.
//         </p>
//         <div className="d-grid gap-2 mt-4">
//           <button 
//             className="btn btn-primary"
//             onClick={onContinue}
//           >
//             Continue Booking Here
//           </button>
//           <button 
//             className="btn btn-outline-secondary"
//             onClick={onBookWithSupplier}
//           >
//             Book Directly on Supplier Portal
//           </button>
//         </div>
//          <button 
//             className="btn btn-link text-muted mt-2"
//             onClick={onHide}
//           >
//             Cancel
//           </button>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default BookingConfirmationModal;

// import React from 'react';
// import Modal from 'react-bootstrap/Modal';

// const BookingConfirmationModal = ({ show, onHide, onBookWithSupplier }) => {
//   return (
//     <Modal 
//       show={show} 
//       onHide={onHide} 
//       centered 
//       backdrop="static" 
//       keyboard={false}
//       contentClassName="border-0 shadow-lg"
//       style={{ borderRadius: '24px' }}
//     >
//       <Modal.Body className="p-4 p-md-5 text-center">
//         {/* ENHANCEMENT: Double-Layered Icon with soft background */}
      

//         <h2 className="fw-bold text-dark mb-2" style={{ letterSpacing: '-0.5px' }}>
//             Redirecting to Supplier
//         </h2>
//         <p className="text-secondary fw-medium mb-4">Finalize your booking securely</p>
        
//         {/* ENHANCEMENT: Transition Visual (Zotrai to Supplier) */}
//         <div className="d-flex align-items-center justify-content-center gap-3 mb-4 p-3 rounded-4 bg-light border border-dashed">
//             <div className="small fw-bold text-primary">Zotrai</div>
//             <i className="ri-arrow-right-line text-muted"></i>
//             <div className="small fw-bold text-dark">Supplier Portal</div>
//         </div>

//         <p className="text-muted small mb-4 px-lg-4" style={{ lineHeight: '1.6' }}>
//             You are moving to the <strong>Official Supplier Portal</strong> to complete your payment. 
//             Don't worry, your search details are being carried forward!
//         </p>

//         {/* Action Buttons */}
//         <div className="d-grid gap-2">
//           <button 
//             className="btn btn-primary py-3 rounded-pill fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
//             onClick={onBookWithSupplier}
//             style={{ 
//                 background: 'linear-gradient(90deg, #2563EB 0%, #1D4ED8 100%)',
//                 border: 'none',
//                 transition: 'all 0.3s ease'
//             }}
//           >
//             Continue With Suppiler <i className="ri-arrow-right-up-line"></i>
//             {/* Continue to Payment <i className="ri-arrow-right-up-line"></i> */}
//           </button>
          
//           <button 
//             className="btn btn-link text-decoration-none text fw-semibold py-2"
//             onClick={onHide}
//           >
//             Cancel and stay here
//           </button>
//         </div>

//         {/* Trust Footer */}
//         <div className="mt-4 pt-4 border-top d-flex align-items-center justify-content-center gap-2">
//             <i className="ri-shield-check-fill text-success fs-5"></i>
//             <p className="small text-muted mb-0">
//                 100% Secure Redirect by <span className="fw-bold text-dark">Zotrai</span> 
//             </p>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default BookingConfirmationModal;



//update by dinesh
import React from 'react';
import Modal from 'react-bootstrap/Modal';

const BookingConfirmationModal = ({ show, onHide, onBookWithSupplier, supplierUrl }) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      backdrop="static" 
      keyboard={false}
      contentClassName="border-0 shadow-lg"
      style={{ borderRadius: '24px' }}
    >
      <Modal.Body className="p-4 p-md-5 text-center">
        <h2 className="fw-bold text-dark mb-2" style={{ letterSpacing: '-0.5px' }}>
            Redirecting to Supplier
        </h2>
        <p className="text-secondary fw-medium mb-4">Finalize your booking securely</p>
        
        {/* ENHANCEMENT: Transition Visual (Zotrai to Supplier) */}
        <div className="d-flex align-items-center justify-content-center gap-3 mb-4 p-3 rounded-4 bg-light border border-dashed">
            <div className="small fw-bold text-primary">Zotrai</div>
            <i className="ri-arrow-right-line text-muted"></i>
            <div className="small fw-bold text-dark">Supplier Portal</div>
        </div>

        <p className="text-muted small mb-4 px-lg-4" style={{ lineHeight: '1.6' }}>
            You are moving to the <strong>Official Supplier Portal</strong> to complete your payment. 
            Don't worry, your search details are being carried forward!
        </p>

        {/* Action Buttons */}
        <div className="d-grid gap-2">
          <button 
            className="btn btn-primary py-3 rounded-pill fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
            onClick={() => onBookWithSupplier(supplierUrl)}
            style={{ 
                background: 'linear-gradient(90deg, #2563EB 0%, #1D4ED8 100%)',
                border: 'none',
                transition: 'all 0.3s ease'
            }}
          >
            Continue With Supplier <i className="ri-arrow-right-up-line"></i>
          </button>
          
          <button 
            className="btn btn-link text-decoration-none text fw-semibold py-2"
            onClick={onHide}
          >
            Cancel and stay here
          </button>
        </div>

        {/* Trust Footer */}
        <div className="mt-4 pt-4 border-top d-flex align-items-center justify-content-center gap-2">
            <i className="ri-shield-check-fill text-success fs-5"></i>
            <p className="small text-muted mb-0">
                100% Secure Redirect by <span className="fw-bold text-dark">Zotrai</span> 
            </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BookingConfirmationModal;